import React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { connect } from "react-redux";
import { LinkList } from "../ecosystem";
import DataComponent from "../common/DataComponent";
import ErrorLoadingTileMessage from "../common/ErrorLoadingTileMessage";
import MiniSpinner from "../common/MiniSpinner";
import ResourceSubTile from "../dashboard/ResourceSubTile";
import HealthPlanTileUsage from "../healthplan/HealthPlanTileUsage";

class AAUserTile extends DataComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isAAUserAPIRuningSlow: false
        }

        this.setMsgIfAAUserAPIRunsSlow = this.setMsgIfAAUserAPIRunsSlow.bind(this);
    }

    componentDidMount() {
        const { SecForShowMsgIfAAUserAPIRunsSlow } = this.props;
        setTimeout(this.setMsgIfAAUserAPIRunsSlow, SecForShowMsgIfAAUserAPIRunsSlow * 1000)
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.AA.DataTile.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    setMsgIfAAUserAPIRunsSlow() {
        const { isHealthPlanDataPending } = this.props;
        if (isHealthPlanDataPending) {
            this.setState({ isAAUserAPIRuningSlow: true });
            logUI("MBHWeb.UI.AA.DataTile.APIRuningSlow.ShowMessage", new Date(), Tools.getURLPath());
        }
    }


    render() {
        const { isAAUserAPIRuningSlow } = this.state;
        const { AATileData, isAALFetching, aalError, insuranceTabText, isHealthPlanDataPending, isMobile, aalDown } = this.props;

        const tileData = AATileData && AATileData.PrimaryAccumulator ? AATileData.PrimaryAccumulator : null;
        const aaTileName = AATileData && AATileData.PlanName ? AATileData.PlanName : "BSWQA-DFW ConnectedCare";
        const showHPTileUsage = !aalError && AATileData;

        return (<ResourceSubTile
            className="hp-tile"
            heading={aaTileName}
            logName={"AAHealthPlan"}
            disabled={aalDown}
            url={"/usage"}
            content={
                <div className="hp-tile__content">
                    <div className="hp-tile__body">
                        {!aalDown
                            ? isHealthPlanDataPending && !tileData && !aalError && !isAAUserAPIRuningSlow
                                ? <MiniSpinner />
                                : <>
                                    {showHPTileUsage
                                        ? <HealthPlanTileUsage
                                            apiRunningSlow={(!aalError && !AATileData && isAAUserAPIRuningSlow) }
                                            healthPlanData={tileData}
                                        />
                                        : <ErrorLoadingTileMessage errorMsg="No information available. Please try again later." />
                                    }
                                </>
                            : <ErrorLoadingTileMessage />
                        }
                    </div>
                    <div className="hp-tile__footer">
                        <LinkList
                            list={[
                                {
                                    text: "View Card",
                                    to: "/idcard",
                                    onClick: (e) => { logUI("MBHWeb.UI.AA.DataTile.Clicked.ViewCard", new Date(), Tools.getURLPath()); },
                                    disabled: aalDown,
                                },
                                {
                                    text: "Claims",
                                    to: "/claims",
                                    onClick: (e) => { logUI("MBHWeb.UI.AA.DataTile.Clicked.Claims", new Date(), Tools.getURLPath()); },
                                    disabled: aalDown,
                                },
                                {
                                    text: insuranceTabText,
                                    to: "/usage",
                                    onClick: (e) => { logUI("MBHWeb.UI.AA.DataTile.Clicked.Usage", new Date(), Tools.getURLPath()); },
                                    disabled: aalDown,
                                },
                                {
                                    text: "Plan",
                                    to: "/benefits",
                                    onClick: (e) => { logUI("MBHWeb.UI.AA.DataTile.Clicked.Benefits", new Date(), Tools.getURLPath()); },
                                    disabled: aalDown,
                                },

                            ]}
                        />
                    </div>
                </div>
            }
        />);
    }


}

const mapStateToProps = (state) => {
    return {
        AATileData: state.healthPlan.healthPlanTileData,
        isAALFetching: state.healthPlan.isHealthPlanDataFetching,
        isHealthPlanDataPending: state.healthPlan.isHealthPlanDataPending,
        aalError: state.healthPlan.healthPlanDataError,
        insuranceTabText: state.memberships.insuranceTabText,
        SecForShowMsgIfAAUserAPIRunsSlow: state.session.serverData && state.session.serverData.SecForShowMsgIfHPAPIRunsSlow ? state.session.serverData.SecForShowMsgIfHPAPIRunsSlow : 15,
        aalDown: state.common.aalDown
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AAUserTile);